import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    padding: theme.spacing(1, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
    },
  },
  versionGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  versionLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  toggleGroup: {
    backgroundColor: theme.palette.background.paper,
    flexWrap: 'wrap',
  },
  toggleButton: {
    textTransform: 'none',
    fontSize: '0.78rem',
    fontWeight: 600,
    padding: theme.spacing(0.5, 2),
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  toggleButtonSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText} !important`,
    borderColor: `${theme.palette.primary.main} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.primary.dark} !important`,
    },
  },
  copyButton: {
    marginLeft: 'auto',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  notice: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: theme.palette.lightPastelYellow,
    border: `1px solid ${theme.palette.pastelOrange}`,
    borderRadius: theme.shape.borderRadius,
  },
  noticeIcon: {
    color: theme.palette.warning.dark,
    flexShrink: 0,
    marginTop: 2,
  },
  noticeText: {
    fontSize: '0.82rem',
    color: theme.palette.warning.dark,
    lineHeight: 1.5,
  },
  documentPaper: {
    padding: theme.spacing(2),
  },
  markdownContainer: {
    maxHeight: 520,
    overflowY: 'auto',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary,
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    '& ul, & ol': {
      paddingLeft: theme.spacing(2.5),
    },
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
    },
    '& th, & td': {
      padding: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
    },
    '& img, & pre, & code': {
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflow: 'auto',
    },
    '& > *': {
      marginBottom: theme.spacing(1),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
    '& blockquote': {
      borderLeft: `3px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(1.5),
      color: theme.palette.text.secondary,
      margin: `${theme.spacing(1)}px 0`,
    },
  },
}))

export default useStyles
